import safeCreateAction from "../../actions/safeCreateAction";
export const showURL = safeCreateAction("SHOW_URL", (url, instructions, subscriber, skippable) => ({ url, instructions, subscriber, skippable: skippable ?? false }));
export const closeBrowser = safeCreateAction("CLOSE_BROWSER");
